var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgF(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.12 122.12"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 61.06,
    cy: 61.06,
    r: 61.06,
    fill: "#010101"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M55.04 91.15H44.92V28.96h35.23v8.6H55.04v19.43h23.53v8.64H55.04v25.52z"
  })));
}
export default SvgF;